export default "__VITE_ASSET__CqdzeszR__"